export default function UpArrow() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.34046 5.19753L2.14396 9.9934C1.64871 10.5595 2.05121 11.445 2.80284 11.445H11.1958C11.3641 11.4452 11.5287 11.3968 11.6702 11.3058C11.8116 11.2147 11.9238 11.0848 11.9934 10.9317C12.0629 10.7785 12.0868 10.6085 12.0622 10.4421C12.0376 10.2757 11.9656 10.1199 11.8547 9.9934L7.65821 5.1984C7.57608 5.10442 7.4748 5.02909 7.36116 4.97748C7.24752 4.92587 7.12415 4.89917 6.99934 4.89917C6.87453 4.89917 6.75116 4.92587 6.63752 4.97748C6.52388 5.02909 6.42259 5.10442 6.34046 5.1984V5.19753Z"
        fill="currentColor"
      />
    </svg>
  );
}
